<template>
  <div class="main">
    <b-card>
      <b-card-body>
        <b-row>
          <b-col md="12" class="d-flex justify-content-end">
  <b-button variant="outline-success" class="mr-2" @click="exportToCSV">
    <feather-icon icon="DownloadIcon" class="mr-50" />
    Export CSV
  </b-button>
  <b-button variant="primary" v-b-modal.modal-add-performance>
    <feather-icon icon="PlusIcon" class="mr-50" />
    Add New
  </b-button>
  <b-modal id="modal-add-performance" ok-only ok-title="Add" centered size="lg" title="Add Reward"
    :hide-footer="true" ref="addPerformance">
    <AddPerformance @PerformaceAdded="closeAddModal" />
  </b-modal>
</b-col>

        </b-row>
        <b-row>
          <b-col md="2" sm="4" class="my-1">
            <b-form-group class="mb-0">
              <label class="d-inline-block text-sm-left mr-50">Per page</label>
              <b-form-select id="perPageSelect" v-model="perPage" size="sm" :options="pageOptions" class="w-50" />
            </b-form-group>
          </b-col>

          <b-col cols="12" class="d-flex justify-content-end mb-2" style="position: relative; z-index: 1;">
            <b-button variant="outline-danger" size="sm" @click="clearFilters">
              Clear Filters
            </b-button>
           
          </b-col>

          <b-col cols="12">
            <b-table striped hover responsive :per-page="perPage" :current-page="currentPage"
              :items="filteredPerformanceRecords" :fields="performance_fields" :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc" :sort-direction="sortDirection">

              <template #head(awardTitle)="scope">
                <div class="d-flex flex-column">
                  <span @click="toggleSort('awardTitle')" style="cursor: pointer">Reward Title</span>
                  <b-form-input v-model="filters.awardTitle" placeholder="Filter by Reward Title" @input="applyFilters"
                    size="sm" />
                </div>
              </template>

              <template #head(employeeId)="scope">
                <div class="d-flex flex-column">
                  <span @click="toggleSort('employeeName')" style="cursor: pointer">Employee</span>
                  <b-form-input v-model="filters.employeeName" placeholder="Filter by Employee" @input="applyFilters"
                    size="sm" />
                </div>
              </template>

              <template #head(gift)="scope">
                <div class="d-flex flex-column">
                  <span @click="toggleSort('gift')" style="cursor: pointer">Gift</span>
                  <b-form-input v-model="filters.gift" placeholder="Filter by Gift" @input="applyFilters" size="sm" />
                </div>
              </template>

              <template #head(price)="scope">
                <div class="d-flex flex-column">
                  <span @click="toggleSort('price')" style="cursor: pointer">Price</span>
                  <b-form-input v-model="filters.price" placeholder="Filter by Price" type="number"
                    @input="applyFilters" size="sm" />
                </div>
              </template>

              <template #head(date)="scope">
                <div class="d-flex flex-column">
                  <span @click="toggleSort('date')" style="cursor: pointer">Date</span>
                  <DatePicker v-model="filters.dateRange" range format="YYYY-MM-DD" placeholder="Select date range"
                    @change="applyFilters" style="width: 100%;" />
                </div>
              </template>

              <template #cell(employeeId)="data">
                {{ getEmployeeName(data.item.employeeId) }}
              </template>

              <template #cell(date)="data">
                    {{ formatDate(data.item.date) }}
                  </template>

              <template #cell(status)="data">
                <b-badge :variant="status[1][data.value]">
                  {{ status[0][data.value] }}
                </b-badge>
              </template>

              <template v-slot:cell(actions)="data">
                <b-dropdown variant="link" toggle-class="p-0" no-caret class="m-1">
                  <template #button-content>
                    <feather-icon icon="MoreVerticalIcon" size="16" class="align-middle text-body" />
                  </template>
                  <b-dropdown-item @click="editPerformance(data.item)">
                    <feather-icon icon="EditIcon" />
                    <span class="align-middle ml-50">Edit</span>
                  </b-dropdown-item>
                  <b-dropdown-item @click="removePerformanceRecord(data.item.performanceRecordId)">
                    <feather-icon icon="TrashIcon" />
                    <span class="align-middle ml-50">Delete</span>
                  </b-dropdown-item>
                </b-dropdown>
              </template>
            </b-table>
          </b-col>

          <b-modal id="modal-edit-performance" ok-only ok-title="Edit" centered size="lg" title="Edit Reward"
            :hide-footer="true" ref="editPerformance">
            <validation-observer ref="formEditPerformance" #default="{ invalid }">
              <b-form @submit.prevent="saveEditedPerformance">
                <b-row>
                  <b-col md="12">
                    <b-form-group label="Reward Title" label-for="awardTitle">
                      <validation-provider rules="required" #default="{ errors }" name="Reward Title" vid="awardTitle">
                        <b-form-input name="awardTitle" placeholder="Reward Title" v-model="editFormData.awardTitle" />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>

                  <b-col sm="12">
                    <b-form-group label="Employee" label-for="employee">
                      <!-- <validation-provider rules="required" #default="{ errors }" name="Employee" vid="employee"> -->
                      <b-form-select :options="employeeOptions" v-model="editFormData.employeeId" disabled />
                      <!-- <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider> -->
                    </b-form-group>
                  </b-col>
                  <b-col md="12">
                    <b-form-group label="Price" label-for="price">
                      <!-- <validation-provider rules="required" #default="{ errors }" name="Price" vid="price"> -->
                      <b-form-input name="price" placeholder="Price" v-model="editFormData.price" type="number" />
                      <!-- <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider> -->
                    </b-form-group>
                  </b-col>
                  <b-col md="12">
                    <b-form-group label="Gift" label-for="gift">
                      <!-- <validation-provider rules="required" #default="{ errors }" name="Gift" vid="gift"> -->
                      <b-form-input name="gift" placeholder="Gift" v-model="editFormData.gift" />
                      <!-- <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider> -->
                    </b-form-group>
                  </b-col>
                  <b-col md="12">
                    <b-form-group label="Date" label-for="date">
                      <validation-provider rules="required" #default="{ errors }" name="Date" vid="date">
                        <b-form-datepicker id="date" placeholder="Start Date" v-model="editFormData.date" />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <!-- submit and reset -->
                  <b-col md="12" class="d-flex justify-content-end">
                    <b-button type="submit" variant="primary" class="mr-2" @click="saveEditedPerformance">
                      Save
                    </b-button>
                    <b-button variant="primary" @click="$bvModal.hide('modal-edit-performance')">Cancel</b-button>
                  </b-col>
                </b-row>
              </b-form>
            </validation-observer>
          </b-modal>
          <b-col cols="12">
            <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" align="center" size="sm"
              class="my-0" />
              <b-form-group>
        Showing 
        {{ totalRows > 0 ? (perPage * (currentPage - 1) + 1) : 0 }} 
        to 
        {{ totalRows > 0 ? Math.min(perPage * currentPage, totalRows) : 0 }} 
        of 
        {{ totalRows > 0 ? totalRows : 0 }} 
        entries
      </b-form-group>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import {
  BTable,
  BAvatar,
  BBadge,
  BRow,
  BCol,
  BFormGroup,
  BSpinner,
  BFormSelect,
  BPagination,
  BInputGroup,
  BFormInput,
  BInputGroupAppend,
  BButton,
  BCard,
  BDropdown,
  BLink,
  BDropdownItem,
  BTab,
  BTabs,
  BFormDatepicker,
} from "bootstrap-vue";

import AddPerformance from "./AddPerformance.vue";
import EditPerformance from "./EditPerformance.vue";
import { mapGetters, mapActions } from 'vuex';
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required, email } from "@validations";

export default {
  components: {
    BCard,
    BTable,
    BAvatar,
    BBadge,
    BRow,
    BCol,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BSpinner,
    BDropdown,
    BLink,
    BDropdownItem,
    BTab,
    BTabs,
    AddPerformance,
    EditPerformance,
    ValidationProvider,
    ValidationObserver,
    BFormDatepicker,
    DatePicker
  },
  data() {
    return {
      employeeOptions: [],
      currentPerformanceRecord: {},
      perPage: 5,
      pageOptions: [3, 5, 10],
      totalRows: 1,
      currentPage: 1,
      filter: null,
      filters: {
        awardTitle: '',
        employeeName: '',
        gift: '',
        price: '',
        dateRange: [null, null]
      },
      filterOn: ["awardTitle", "employeeName", "gift", "price", "date"],
      performance_fields: [
        { key: "awardTitle", label: "Reward Title", sortable: true },
        { key: "employeeId", label: "Employee", sortable: true },
        { key: "gift", label: "Gift", sortable: true },
        { key: "price", label: "Price", sortable: true },
        { key: "date", label: "Date", sortable: true },
        { key: "actions", label: "Actions" },
      ],
    };
  },
  computed: {
    ...mapGetters('performancerecordModule', {
      performanceRecords: 'performanceRecords',
      loading: 'loading',
    }),
    ...mapGetters("employeeModule", {
      employeeList: "employees",
      loading: "loading",
    }),
    mergedPerformanceRecords() {
      return this.performanceRecords.map(record => {
        const employee = this.employeeList.find(emp => emp.id === record.employeeId);
        return {
          ...record,
          employeeName: employee ? `${employee.firstName} ${employee.lastName}` : "",
        };
      });
    },
    filteredPerformanceRecords() {
      // Ensure all strings are compared case-insensitively
      const lowerCaseString = (str) => str ? str.toString().toLowerCase() : '';

      return this.performanceRecords.filter(record => {
        const matchesAwardTitle = !this.filters.awardTitle || lowerCaseString(record.awardTitle).includes(lowerCaseString(this.filters.awardTitle));
        const matchesEmployee = !this.filters.employeeName || lowerCaseString(record.employeeName).includes(lowerCaseString(this.filters.employeeName));
        const matchesGift = !this.filters.gift || lowerCaseString(record.gift).includes(lowerCaseString(this.filters.gift));
        const matchesPrice = !this.filters.price || record.price.toString().includes(this.filters.price.toString());

        // Handling date range filter
        const [startDate, endDate] = this.filters.dateRange;
        const recordDate = new Date(record.date);
        const matchesDate = (!startDate || recordDate >= new Date(startDate)) &&
          (!endDate || recordDate <= new Date(endDate));

        // Return true if all filters match
        return matchesAwardTitle && matchesEmployee && matchesGift && matchesPrice && matchesDate;
      });
    }
  },
  methods: {
    ...mapActions('performancerecordModule', ['getPerformanceRecordListAction', 'removePerformanceRecordAction', 'updatePerformanceRecordAction']),
    ...mapActions("employeeModule", ["getEmployeeListAction"]),
    getEmployeeName(id) {
      const employee = this.employeeList.find((s) => s.id === id);
      return employee ? employee.firstName + " " + employee.lastName : "-";
    },

    formatDate(date) {
      if(date != null){
        const options = { year: "numeric", month: "short", day: "numeric" };
        return new Date(date).toLocaleDateString("en-US", options);
      }
      else {
        return "-";
      }
      
    },

    addPerformance(performanceRecord) {
      this.currentPerformanceRecord = performanceRecord;
      this.getPerformanceRecordListAction().then(() => {
      this.totalRows = this.performanceRecords.length;
    });
    },
    removePerformanceRecord(id) {
      this.$swal({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.removePerformanceRecordAction(id)
            .then(() => {
              this.$swal({
                icon: 'success',
                title: 'Deleted!',
                text: 'Performence Record has been deleted',
                customClass: {
                  confirmButton: 'btn btn-success',
                },
              });
              this.getPerformanceRecordListAction().then(() => {
                this.totalRows = this.performanceRecords.length;
              });
            })
            .catch((error) => {
              this.$swal({
                icon: 'error',
                title: 'Error!',
                text: error.response.data.message,
                customClass: {
                  confirmButton: 'btn btn-success',
                },
              });
              this.getPerformanceRecordListAction().then(() => {
                this.totalRows = this.performanceRecords.length;
              });
            });
        } else if (result.dismiss === 'cancel') {
          this.$swal({
            title: 'Cancelled',
            text: 'Performance not deleted',
            icon: 'error',
            customClass: {
              confirmButton: 'btn btn-success',
            },
          });
        }
      });
    },

    editPerformance(item) {
      this.getEmployeeListAction().then(() => {
        this.employeeOptions = this.employeeList.map((employee) => ({
          value: employee.id,
          text: `${employee.firstName} ${employee.lastName}`,
        }));
      });
      this.editFormData = { ...item };
      this.$refs.editPerformance.show();

    },
    successEdit() {
      this.$swal({
        title: "Proformance Updated!",
        text: "You have successfully updated the proformance!",
        icon: "success",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
    },

    errorEdit(error) {
      this.$swal({
        title: "Error!",
        text: error ? error : " Failed!",
        icon: "error",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
    },

    async saveEditedPerformance() {
      const isValid = await this.$refs.formEditPerformance.validate();
      if (isValid) {
        this.loading = true;
        let loader = this.$swal({
          title: 'Processing...',
          text: 'Please wait while the Performance is being updated',
          onOpen: () => {
            this.$swal.showLoading();
          },
          allowOutsideClick: () => !this.$swal.isLoading(),
          buttonsStyling: false,
          showConfirmButton: false,
        });
        try {
          const payload = {
            performanceRecordId: this.editFormData.performanceRecordId,
            awardTitle: this.editFormData.awardTitle,
            employeeId: this.editFormData.employeeId,
            price: this.editFormData.price,
            gift: this.editFormData.gift,
            date: this.editFormData.date,

          };
          console.log("edit payload", payload);

          await this.updatePerformanceRecordAction(payload);
          loader.close();
          this.successEdit();
          this.$bvModal.hide("modal-edit-performance");
          this.loading = false;
          // Reload Performance data
          await this.getPerformanceRecordListAction();
        } catch (error) {
          loader.close();
          this.loading = false;
          console.error(
            "Error in saveEditedPerformance:",
            error.response || error.message || error
          );
          this.errorEdit(
            error.response ? error.response.data.message : error.message
          );
        }
      }
    },
    async closeAddModal() {
      this.$refs.AddPerformance.hide();
      await this.getPerformanceRecordListAction().then(() => {
        this.totalRows = this.performanceRecords.length;
      });
      this.totalRows = this.getPerformanceRecordListAction.length;
    },
    async closeEditModal() {
      this.$refs.EditPerformance.hide();
      await this.getPerformanceRecordListAction().then(() => {
        this.totalRows = this.performanceRecords.length;
      });
      this.totalRows = this.performanceRecords.length;
    },

    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    applyFilters() {
      this.currentPage = 1; // Reset to the first page when filters are applied
    },
    clearFilters() {
      // Reset each filter to its initial state
      this.filters = {
        awardTitle: '',
        employeeName: '',
        gift: '',
        price: '',
        dateRange: [null, null] // Clear date range filter
      };
      // Reset the current page to the first page after clearing filters
      this.currentPage = 1;
    },

    exportToCSV() {
    const csvContent = [];
    const headers = this.performance_fields
    .filter(field => field.key !== 'actions')
    .map(field => field.label).join(","); // Get headers from fields
    csvContent.push(headers);

    // Add rows
    this.filteredPerformanceRecords.forEach(record => {
      const row = [
        record.awardTitle,
        this.getEmployeeName(record.employeeId),
        record.gift,
        record.price,
        this.formatDate(record.date),
      ].map(value => `"${value}"`).join(",");
      csvContent.push(row);
    });

    // Create Blob and download link
    const blob = new Blob([csvContent.join("\n")], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    const url = URL.createObjectURL(blob);
    link.setAttribute("href", url);
    link.setAttribute("download", "rewards_records.csv");
    link.style.visibility = "hidden";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  },
  },

  async mounted() {
    await this.getEmployeeListAction();
    await this.getPerformanceRecordListAction().then(() => {
      this.totalRows = this.performanceRecords.length;
    });
  },

};

</script>
